<ng-container>
  <div mat-dialog-title align="end">
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <div mat-dialog-content>
    <div class="flex flex-row justify-center">
      <mat-icon class="icon-size-16" *ngIf="data.type" svgIcon="confirm_{{ data.type }}"></mat-icon>
    </div>
    <div class="text-h4 font-bold text-theme-navy-blue text-center">{{ data.title }}</div>
    <p class="text-b1 font-normal text-theme-gray text-center mb-6 whitespace-pre-line">{{ data.description }}</p>
  </div>
  <div mat-dialog-actions align="center">
    <button *ngIf="!data.hideDismissButton" mat-button (click)="dimiss()">{{ data.dismissLabel ?? 'Cancel' }}</button>
    <button mat-flat-button color="primary" (click)="confirm()">{{ data.confirmLabel ?? 'OK' }}</button>
  </div>
</ng-container>
